import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Wed Aug 08 2018
 * @author SKu
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { observer } from 'mobx-react';
import * as React from 'react';
import rootStore from '../../../shared/stores/RootStore';
import { StoreName } from '../../../shared/stores/StoreName';

var WithPermission =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WithPermission, _React$Component);

  function WithPermission() {
    var _this;

    _classCallCheck(this, WithPermission);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WithPermission).apply(this, arguments));
    _this.keycloakStore = rootStore.getStore(StoreName.Keycloak);
    return _this;
  }

  _createClass(WithPermission, [{
    key: "render",
    value: function render() {
      return this.keycloakStore.userHasPermissions(this.props.permissionTypes, this.props.some) ? this.props.children : React.createElement(React.Fragment, null);
    }
  }]);

  return WithPermission;
}(React.Component);

WithPermission = __decorate([observer], WithPermission);
export default WithPermission;